export default {
  getUsersChats: state => state.usersChats,
  getPatientsChats: state => state.patientsChats,
  mimirmanChat: state => state.mimirmanChat,
  getContacts: state => state.contacts,
  getActiveChatInfo: state => state.activeChatInfo,
  getNewMessage: state => state.newMessage,
  activeMessenger: state => state.activeMessenger,
}
